import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'components/Modal'

import TranscriptPicker from './TranscriptPicker'

// Wraps the existing TranscriptPicker in a modal. Provider-agnostic: the
// parent decides which provider's transcripts to load and passes them in.
const GenerateProfileModal = ({
  show,
  onClose,
  providerName,
  transcripts,
  isLoading,
  error,
  onRetry,
  onGenerate,
  isGenerating,
  generateError
}) => {
  return (
    <Modal show={show} closeModal={onClose} scrollable>
      <h2 className="mb-10" style={{ fontSize: 22 }}>
        Generate a new profile
      </h2>
      <p className="text-gray-dark mb-20">
        Pick a handful of recent meetings from
        {providerName ? ` ${providerName}` : ' your source'} that
        show you leading conversations — coaching, decisions,
        planning, hard feedback — and we&apos;ll generate a
        profile from them.
      </p>
      <TranscriptPicker
        transcripts={transcripts}
        isLoading={isLoading}
        error={error}
        onRetry={onRetry}
        onGenerate={onGenerate}
        isGenerating={isGenerating}
        generateError={generateError}
        providerName={providerName}
      />
    </Modal>
  )
}

GenerateProfileModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  providerName: PropTypes.string,
  transcripts: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.object,
  onRetry: PropTypes.func,
  onGenerate: PropTypes.func,
  isGenerating: PropTypes.bool,
  generateError: PropTypes.object
}

export default GenerateProfileModal
